module.exports = __webpack_public_path__ + "static/bell-55e42f9378e47d27f2305b1e84b5548b.gif";